"use client";

import styles from "./CurrentTime.module.scss";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useIsClient } from "@uidotdev/usehooks";
const getCurrentTime = () => {
  return new Date().toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default function CurrentTime() {
  const t = useTranslations();
  const isClient = useIsClient();
  const [time, setTime] = useState(getCurrentTime());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      {isClient && (
        <div className={styles.time}>
          <span className={styles.time__title}>{t("time")}</span>
          <div>{time}</div>
        </div>
      )}
    </>
  );
}
